export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14953.0841d9f5.jpg";